module.exports = __webpack_public_path__ + "img/IMG_8431.d11d301e.jpeg";